{
    "quote": "Devis",
    "order": "Commande",
    "order_info__1_title": "Client",
    "order_info__1_item_title__customer_id": "N° client",
    "order_info__1_item_title__customer": "Client",
    "order_info__1_item_title__sales_manager": "Commercial",
    "order_info__1_item_title__customer_contact": "Personne de contact",
    "order_info__1_item_title__po_number": "N° de commande client",
    "quote_info__2_title": "Configuration du devis",
    "order_info__2_title": "Configuration de la commande",
    "order_info__2_item_title__created_date": "Date de création",
    "order_info__2_item_title__order_type": "Type de commande",
    "order_info__2_item_title__collector": "Saisi par",
    "header_info_title": "En-tête",
    "header_info__sum_line_items": "Total des lignes",
    "header_info__sum_incl_surcharges": "Total avec suppléments",
    "header_info__gross_margin": "Marge",
    "header_info__gross_margin_percent": "Marge %",
    "header_info__total_line": "Nombre de lignes",
    "order_info__3_title": "Logistique",
    "order_info__3_item_title__warehouse": "Entrepôt",
    "order_info__3_item_title__shipping_method": "Mode d'expédition",
    "order_info__3_item_title__service_provider": "Prestataire",
    "order_info__3_item_title__delivery_address": "Adresse de livraison",
    "order_info__3_item_title__billing_address": "Adresse de facturation",
    "order_info__3_item_title__order_desired_delivery_date": "Date de livraison souhaitée",
    "order_info__3_item_title__quote_due_date": "Valable jusqu'au",
    "tabs__details": "Détails",
    "tabs__attachments": "Documents PDF",
    "attachments__column_document": "Document",
    "attachments__column_date_added": "Date de création",
    "attachments__column_type": "Type de document",
    "attachments__action_preview": "Aperçu",
    "attachments__action_download": "Télécharger",
    "attachments__error_preview": "Impossible d'ouvrir le document",
    "attachments__error_download": "Impossible de télécharger le document"
}
